import { render, staticRenderFns } from "./YUserDetail.vue?vue&type=template&id=59a17bde&scoped=true"
import script from "./YUserDetail.vue?vue&type=script&lang=js"
export * from "./YUserDetail.vue?vue&type=script&lang=js"
import style0 from "./YUserDetail.vue?vue&type=style&index=0&id=59a17bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a17bde",
  null
  
)

export default component.exports